import React, {} from "react"
import axios from 'axios';
import { logApiRequest } from '../mixpanelInterface';
import CreatePriceStr from './CreatePriceStr';
const paths = require('../../../paths.json');


export default function UpgradeSubInfoPopup(
      current_tier, 
      influencer, 
      upgrade_tier, 
      current_tier_price, 
      upgrade_price, 
      data_func,
      influencer_icon_image,
      bronze_tier_perks, 
      silver_tier_perks, 
      gold_tier_perks,
      bronze_price,
      silver_price,
      gold_price,
      current_free_trial,
      influencer_name,
      free_name,
      bronze_name,
      silver_name,
      gold_name,
      free_active,
      bronze_active,
      silver_active,
      gold_active,
      currency,
      bronze_annual_price,
      silver_annual_price,
      gold_annual_price,
      bronze_show_annual_reduction,
      silver_show_annual_reduction,
      gold_show_annual_reduction,
      selected_duration,
      async_tier_perks,
      async_price,
      async_name,
      async_active,
      async_annual_price,
      async_show_annual_reduction,
      ) {
    var current_tier_str = ''
    if (current_tier === 0) {
      current_tier_str = free_name
    } else if (current_tier == 1){
      current_tier_str = bronze_name
    } else if (current_tier == 2){
      current_tier_str = silver_name
    } else if (current_tier == 3){
      current_tier_str = gold_name
    } else if (current_tier == 4){
      current_tier_str = async_name
    }
    var upgrade_tier_str = ''
    if (upgrade_tier === 0) {
      upgrade_tier_str = free_name
    } else if (upgrade_tier == 1){
      upgrade_tier_str = bronze_name
    } else if (upgrade_tier == 2){
      upgrade_tier_str = silver_name
    } else if (upgrade_tier == 3){
      upgrade_tier_str = gold_name
    } else if (upgrade_tier == 4){
      upgrade_tier_str = async_name
    }
    var access_token = localStorage.getItem("fitwith_access_token");
      const startTime = performance.now();
    axios(
        {
            url:paths.BACKEND_URL + "api/current_subscription_period/" + influencer,
            method:"get",
            headers: {
                'Content-type': 'application/json',
            },
            withCredentials: true
        },
    ).then((res) => {
         logApiRequest(paths.BACKEND_URL + "api/current_subscription_period/" + influencer, performance.now() - startTime);
        if (!res.data.access_denied) {
            // calculate the difference price
            let upgrade_price_str = CreatePriceStr(Math.round(upgrade_price * (1-res.data.discount)), currency)
            if (upgrade_tier === 4 && current_free_trial === true){
              var upgrade_cost_str = CreatePriceStr(
                  String(Math.round((upgrade_price) * res.data.subscription_popup_current_period_perc * (1-res.data.discount))),
                  currency,
              )
            } else {
              var upgrade_cost_str = CreatePriceStr(
                String(Math.round((upgrade_price - current_tier_price) * res.data.subscription_popup_current_period_perc * (1-res.data.discount))),
                currency,
            )
            }
            this.setState(
                {
                  subscribe_popup_icon_image: influencer_icon_image,
                  subscribe_popup_current_tier: current_tier,
                  subscribe_popup_bronze_perks_text: bronze_tier_perks,
                  subscribe_popup_silver_perks_text: silver_tier_perks,
                  subscribe_popup_gold_perks_text: gold_tier_perks,
                  subscribe_popup_bronze_price: bronze_price,
                  subscribe_popup_silver_price: silver_price,
                  subscribe_popup_gold_price: gold_price,
                  subscribe_popup_free_active: free_active,
                  subscribe_popup_bronze_active: bronze_active,
                  subscribe_popup_silver_active: silver_active,
                  subscribe_popup_gold_active: gold_active,
                  subscribe_popup_free_name: free_name,
                  subscribe_popup_bronze_name: bronze_name,
                  subscribe_popup_silver_name: silver_name,
                  subscribe_popup_gold_name: gold_name,
                  subscription_popup_info_page_type: 'upgrade',
                  subscribe_popup_influencer: influencer,
                  subscribe_popup_influencer_name: influencer_name,
                  subscription_popup_info_open: true,
                  subscription_popup_info_text_1: "Are you sure you want to completely unsubscribe to " + influencer_name + '?',
                  subscription_popup_info_text_2: "",
                  upgrade_tier: upgrade_tier,
                  upgrade_cost_str: upgrade_cost_str,
                  upgrade_price_str: upgrade_price_str,
                  discount: res.data.discount,
                  subscribe_popup_open: false,
                  subscription_popup_info_open: true,
                  subscribe_popup_current_free_trial: current_free_trial,
                  subscribe_popup_bronze_annual_price: bronze_annual_price,
                  subscribe_popup_silver_annual_price: silver_annual_price,
                  subscribe_popup_gold_annual_price: gold_annual_price,
                  subscribe_popup_bronze_show_annual_reduction: bronze_show_annual_reduction,
                  subscribe_popup_silver_show_annual_reduction: silver_show_annual_reduction,
                  subscribe_popup_gold_show_annual_reduction: gold_show_annual_reduction,
                  // subscription_popup_info_text_1: 'Are you sure you want to upgrade to ' + upgrade_tier_str + ' tier of ' + influencer + '?',
                  // subscription_popup_info_text_2: 'You will be charged ' + upgrade_cost_str + ' and be upgraded to ' + upgrade_tier_str + ' once payment is recieved. Your monthly subscription will then be ' + upgrade_price_str + '.',
                  // subscription_popup_info_button_click_process: () => this.UpgradeSubscription(influencer, upgrade_tier, data_func),
                  subscribe_popup_open: false,
                  data_func: data_func,
                  subscription_popup_info_open: true,
                  // subscription_popup_info_text_1: 'Are you sure you want to downgrade to ' + downgrade_tier_str + ' tier of ' + influencer + '?',
                  // subscription_popup_info_text_2: text2_str,
                  // subscription_popup_info_button_text: 'DOWNGRADE',
                  // subscription_popup_info_button_click_process: () => this.DowngradeSubscription(influencer, downgrade_tier, data_func),
                  subscription_popup_info_button_click_process: this.UpgradeSubscription,    
                  // subscribe_popup_icon_image: influencer_icon_image,
                  // subscribe_popup_current_tier: tier,
                  // subscribe_popup_free_perks_text: free_tier_perks,
                  // subscribe_popup_bronze_perks_text: bronze_tier_perks,
                  // subscribe_popup_silver_perks_text: silver_tier_perks,
                  // subscribe_popup_gold_perks_text: gold_tier_perks,
                  // subscribe_popup_bronze_price: bronze_price,
                  // subscribe_popup_silver_price: silver_price,
                  // subscribe_popup_gold_price: gold_price,
                  // subscription_popup_info_page_type: 'cancel',
                  // subscribe_popup_influencer_name: influencer,
                  // subscription_popup_info_renewal_date: renewal_date,
                  // subscription_popup_info_open: true,
                  // subscription_popup_info_text_1: "Are you sure you want to completely unsubscribe to " + influencer + '?',
                  // subscription_popup_info_text_2: "",
                  // upgrade_tier: upgrade_tier,
                  // subscribe_popup_open: false,
                  // subscription_popup_info_open: true,
                  // subscription_popup_info_text_1: 'Are you sure you want to upgrade to ' + upgrade_tier_str + ' tier of ' + influencer + '?',
                  // subscription_popup_info_text_2: 'You will be charged ' + upgrade_cost_str + ' and be upgraded to ' + upgrade_tier_str + ' once payment is recieved. Your monthly subscription will then be ' + upgrade_price_str + '.',
                  // subscription_popup_info_button_click_process: () => this.UpgradeSubscription(influencer, upgrade_tier, data_func),
                  subpopup_info_selected_duration: selected_duration,
                  subscribe_popup_async_perks_text: async_tier_perks,
                  subscribe_popup_async_price: async_price,
                  subscribe_popup_async_active: async_active,
                  subscribe_popup_async_name: async_name,
                  subscribe_popup_async_annual_price: async_annual_price,
                  subscribe_popup_async_show_annual_reduction: async_show_annual_reduction,
                }
            )
        } else {
            throw new Error(res);
        }
    })
    .catch(error => {
        // console.log(error)
        // setTimeout(() => {  console.log("test1"); }, 200000);
        window.location.assign('/register?post_url='+influencer)
    })
}
